import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, Tooltip, Legend, PointElement, LinearScale } from 'chart.js';
import { Bubble } from 'react-chartjs-2';

import { semAreasPlugin, chartAreaBorderPlugin } from '/src/utilities/chart-plugins';
import { colors } from '/src/utilities/formats';
import { saeByIc, saeByIcQuads, preProcess } from '../../utilities/sae-utils';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

export default function SAEMini({ formData = null, institutionData = null, y2 = 1.5 }) {

    const [datasets, setData] = useState(null);
    const [rawData, setRawData] = useState(null);

    const ic = saeByIc.filter((ic) => {
        return ic.ic2025 == institutionData.post_meta.ic2025.value;
    }).pop();

    y2 = ic.yLine;

    useEffect(() => {
        async function fetchData() {
            try {
                let loadedData;
                if (!rawData) {
                    const response = await fetch("/wp-content/plugins/ace-carnegie-institution-charts/frontend/dist/data/data.json");
                    loadedData = preProcess(await response.json(), institutionData?.post_meta.unitid.value, 3);
                    setRawData(loadedData);
                }
                else {
                    loadedData = rawData;
                }
                loadedData = filterByUnitid(loadedData, institutionData?.post_meta.unitid.value);
                let aggregate = aggregateData(loadedData);
                setData({ datasets: aggregate });
            } catch (err) {
                console.log(err);
            }
        }
        fetchData();
    }, [formData ?? null]);


    const opts = {
        animation: false,
        responsive: true,
        hover: { mode: null },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },
        scales: {
            x: {
                min: 0,
                max: 3.03,
                grid: {
                    display: false
                },
                ticks: {
                    display: false
                },

                title: {
                    display: true,
                    text: "Access",
                    padding: 5,
                    font: {
                        size: 10
                    }
                }
            },
            y: {
                min: 0,
                max: 3.023,
                ticks: {
                    display: false
                },
                grid: {
                    display: false
                },
                title: {
                    display: true,
                    text: "Earnings",
                    padding: 5,
                    font: {
                        size: 10
                    }
                }
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            semAreas: {
                x1: 1,
                y1: 1,
                y2: y2,
                shade: saeByIcQuads[institutionData.post_meta.saec2025.value],
                showLabels: false,
                lineWidth: 1,
                lineColor: '#C9C9C9',
            },
            tooltip: {
                enabled: false,
            },
            chartAreaBorder: {
                borderColor: '#C9C9C9',
                borderWidth: 1,
            }
        },

    }


    if (!datasets) return null;

    let plugins = [
        semAreasPlugin,
        chartAreaBorderPlugin
    ];
    return (
        <>
            <Bubble
                data={datasets}
                options={opts}
                plugins={plugins}
                updateMode="show"
            />
        </>
    );
}

function aggregateData(data, field, name_filter = null) {
    const datasets = [];
    let filteredData = data;
    datasets.push({
        label: 'Overall',
        data: filteredData,
        parsing: {
            xAxisKey: 'x',
            yAxisKey: 'y'
        },
        borderColor: colors.blue,
        backgroundColor: colors.blue,
        borderWidth: 1,
        radius: 2,
    });
    return datasets;
}



function filterByUnitid(data, unitid) {
    return data.filter((row) => row.unitid == unitid);
}






